/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');

const Q_ranged_cluster = function (altNode, actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.NO] = altNode;

  if (BattleCalc.getEquippedAbility(actor, 'psyche_out')) {
    node.branches[node.YES] = new UseAbility({
      actor,
      abilityHandle: 'psyche_out',
      altNode: node.branches[node.NO],
    });
  } else {
    node.branches[node.YES] = altNode;
  }

  node.query = function (target) {
    if (!target) {
      return null;
    }

    var enemyCluster = AICalc.defineEnemyCluster(
      target,
      this.battleState.getEnemiesOfUnit(this.actor)
    );

    if (
      enemyCluster.length >= 2 &&
      !BattleCalc.getCondition(target, 'enraged') &&
      !BattleCalc.getCondition(target, 'unshakeable')
    ) {
      return this.branches[this.YES].query(target);
    } else {
      return this.branches[this.NO].query(target);
    }
  };

  return node;
};
module.exports = Q_ranged_cluster;
